var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 6.03125C10.2031 6.62668 9.72043 7.10938 9.125 7.10938C8.52957 7.10938 8.04688 6.62668 8.04688 6.03125C8.04688 5.43582 8.52957 4.95312 9.125 4.95312C9.72043 4.95312 10.2031 5.43582 10.2031 6.03125Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 6.03125C16.9531 6.62668 16.4704 7.10938 15.875 7.10938C15.2796 7.10938 14.7969 6.62668 14.7969 6.03125C14.7969 5.43582 15.2796 4.95312 15.875 4.95312C16.4704 4.95312 16.9531 5.43582 16.9531 6.03125Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 12.4062C10.2031 13.0017 9.72043 13.4844 9.125 13.4844C8.52957 13.4844 8.04688 13.0017 8.04688 12.4062C8.04688 11.8108 8.52957 11.3281 9.125 11.3281C9.72043 11.3281 10.2031 11.8108 10.2031 12.4062Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 12.4062C16.9531 13.0017 16.4704 13.4844 15.875 13.4844C15.2796 13.4844 14.7969 13.0017 14.7969 12.4062C14.7969 11.8108 15.2796 11.3281 15.875 11.3281C16.4704 11.3281 16.9531 11.8108 16.9531 12.4062Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 18.7812C10.2031 19.3767 9.72043 19.8594 9.125 19.8594C8.52957 19.8594 8.04688 19.3767 8.04688 18.7812C8.04688 18.1858 8.52957 17.7031 9.125 17.7031C9.72043 17.7031 10.2031 18.1858 10.2031 18.7812Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 18.7812C16.9531 19.3767 16.4704 19.8594 15.875 19.8594C15.2796 19.8594 14.7969 19.3767 14.7969 18.7812C14.7969 18.1858 15.2796 17.7031 15.875 17.7031C16.4704 17.7031 16.9531 18.1858 16.9531 18.7812Z",
    fill: "#141719",
    stroke: "#141719",
    strokeWidth: 0.09375
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.381c17487991f5e90a2e6c36196b011d.svg";
export { ForwardRef as ReactComponent };